<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Edit Lecture</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>

    <section class="modal-card-body" style="min-height: 500px">
      <b-field label="Lecture Date" label-position="on-border">
        <b-datepicker
          v-model="formData.lectureDate"
          placeholder="Click to select..."
          icon="calendar"
          trap-focus
          :date-formatter="(date) => date.toLocaleDateString()"
        >
          <b-button
            label="Today"
            type="is-primary"
            icon-left="calendar"
            @click="formData.lectureDate = new Date()"
          />
          <b-button
            label="Clear"
            type="is-danger"
            icon-left="eraser"
            outlined
            @click="formData.lectureDate = null"
          />
        </b-datepicker>
      </b-field>

      <b-field label="Week Number" label-position="on-border">
        <b-input :value="lecture.weekNumber" disabled></b-input>
      </b-field>
    </section>

    <footer class="modal-card-foot">
      <b-button
        label="Save Changes"
        type="is-primary"
        @click="save"
        :disabled="!hasChanges"
      />
      <b-button label="Cancel" @click="$emit('close')" />
    </footer>
  </div>
</template>

<script>
export default {
  name: "LectureEditor",

  props: {
    lecture: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: {
        lectureDate: new Date(this.lecture.lectureDate),
      },
    };
  },

  computed: {
    hasChanges() {
      if (!this.formData.lectureDate) return false;
      const currentDate = new Date(this.lecture.lectureDate);
      return (
        this.formData.lectureDate.toDateString() !== currentDate.toDateString()
      );
    },
  },

  methods: {
    save() {
      this.$emit("save", {
        lectureId: this.lecture.id,
        lectureDate: this.formData.lectureDate,
      });
      this.$emit("close");
    },
  },
};
</script>
